module.exports = __webpack_public_path__ + "network-danger.26460320.png";